declare global {
  interface Window {
    hj: (type: string, value: string) => void;
  }
}

export const pushVirtualPageView = (pageViewTitle: string) => {
  if (window.hj) {
    window.hj("event", `/claimcheck-airspeed/${pageViewTitle}`);
  }
};
